export default "__VITE_ASSET__Vpd1$_Wx__"